import React from 'react';
import { motion } from 'motion/react';
import { BLOG_POSTS } from '@/src/constants';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Blog() {
  return (
    <section className="py-24 bg-accent/5">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-24 gap-10">
          <div>
            <h2 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold mb-8 tracking-tighter">
              Security <span className="text-accent">Insights</span>
            </h2>
            <p className="text-2xl text-muted-foreground max-w-3xl font-light leading-relaxed">
              Stay ahead of the curve with our latest analysis on emerging threats, compliance shifts, and business security strategy.
            </p>
          </div>
          <Link to="/resources" className="flex items-center gap-3 text-accent font-bold text-lg group whitespace-nowrap pb-2">
            View All Articles <ArrowRight className="w-6 h-6 transition-transform group-hover:translate-x-2" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {BLOG_POSTS.map((post, index) => (
            <motion.article
              key={post.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="relative h-64 rounded-3xl overflow-hidden mb-6">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  referrerPolicy="no-referrer"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-background/80 backdrop-blur-md text-[10px] font-bold uppercase tracking-widest text-accent">
                    {post.category}
                  </span>
                </div>
              </div>
              
              <div className="flex items-center gap-4 mb-4 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
                <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {post.date}</span>
                <span className="flex items-center gap-1.5"><User className="w-3.5 h-3.5" /> {post.author}</span>
              </div>

              <h3 className="text-xl font-bold mb-4 group-hover:text-accent transition-colors leading-tight">
                {post.title}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed mb-6">
                {post.excerpt}
              </p>
              
              <div className="flex items-center gap-2 text-accent font-bold text-xs">
                Read Article <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
